<mat-toolbar color="primary" id="header">
  <mat-toolbar-row>
    <div style="cursor: pointer" (click)="router.navigate(['/inicio'])">
      <img src="../assets/images/Fosil-logo-white.png" style="width: 50px" alt="" />
      <span style="margin-left: 10px">Fosil</span>
    </div>
    <span class="example-spacer"></span>
    @if (size > 1000) {
    <div style="width: 100%">
      <h2 class="company-name">{{ companyName }}</h2>
    </div>
    }
    @if (nombreUsuario != '') {
    <div style="margin: 6px 30px 0 0; cursor: pointer">
      <mat-icon [matMenuTriggerFor]="beforeMenu" [matBadge]="notifications.length"
        matBadgeColor="warn" aria-hidden="false">notification_important</mat-icon>
      <span class="cdk-visually-hidden"> </span>
      <mat-menu #beforeMenu="matMenu" xPosition="before">
        @for (data of notifications; track trackByNotificationId($index, data)) {
        <button mat-menu-item (click)="redirect(data, $event)"
          style="height: auto; line-height: 1.4; padding: 10px 16px;">
          <div style="display: flex; flex-direction: column; max-width: 300px;">
            <div style="font-weight: bold; font-size: 1rem; white-space: normal; margin-bottom: 4px;">
              {{ data.title }}
            </div>
            <div style="font-size: 0.85rem; white-space: normal; color: #666;">
              {{ data.description }}
            </div>
          </div>
        </button>
        }
      </mat-menu>
    </div>
    }
    <h4 style="color: white; margin-right: 20px">
      {{ nombreUsuario | uppercase }}
    </h4>
    @if (logged) {
    <mat-icon [matMenuTriggerFor]="menu" matRipple class="menu_more_vert"
      aria-label="Example delete icon">more_vert</mat-icon>
    }
    <mat-menu #menu="matMenu">
      <button mat-menu-item routerLink="/administracion/perfil">
        <mat-icon aria-label="Example home icon">accessibility</mat-icon>
        Perfil
      </button>
      <button mat-menu-item [matMenuTriggerFor]="themeMenu">
        <mat-icon>palette</mat-icon>
        Tema
      </button>
      <button mat-menu-item (click)="Logout()">
        <mat-icon aria-label="Example home icon">power_settings_new</mat-icon>
        Salir
      </button>
    </mat-menu>

    <mat-menu #themeMenu="matMenu">
      @for (theme of availableThemes; track theme) {
      <button mat-menu-item (click)="changeTheme(theme)">
        <mat-icon>{{ theme.name === activeTheme?.name ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
        {{ theme.name }}
      </button>
      }
    </mat-menu>

  </mat-toolbar-row>
</mat-toolbar>

<div style="display: flex; width: 100%;">
  @if (logged && size > minimalScreen && !isMobile) {
  <div>
    <app-side-bar [active]="activeSideBar" (handlerSideBarEvent)="handlerSideBarEvent($event)"></app-side-bar>
  </div>
  }

  <div class="main-content-area" [style.height.vh]="mainRouterHeight" style="overflow: hidden; width: 100%; display: flex; flex-direction: column;">
    @if (logged) {
    <div class="fixed-breadcrumb" #breadcrumbElement>
      <app-bread-crumb [menu]="menuBreadCrumb"
        (selectRouter)="eventService.emitEventBreadCumb($event)"></app-bread-crumb>
    </div>
    }

    <div class="router-outlet-container">
      <router-outlet (activate)="componentAdded($event)" (deactivate)="componentRemoved($event)"></router-outlet>
    </div>

    @if (logged && size > 813 && size < minimalScreen) { <div class="iconHome">
      <button color="warn" mat-fab aria-label="Inicio" (click)="router.navigate(['/inicio'])">
        <mat-icon>home</mat-icon>
      </button>
  </div>
  }
</div>
</div>